import { CountryFlagType } from '@cdaas/reusable-components-daas/dist/src/components/CountrySwitcher/types';

interface CountryConstants {
  name: string;
  code: string;
  countryFlag: CountryFlagType;
  currency: string;
}

export const Denmark: CountryConstants = {
  name: 'Denmark',
  code: 'DK',
  countryFlag: 'den',
  currency: 'DKK',
};

export const Estonia: CountryConstants = {
  name: 'Estonia',
  code: 'EE',
  countryFlag: 'est',
  currency: 'EUR',
};

export const Finland: CountryConstants = {
  name: 'Finland',
  code: 'FI',
  countryFlag: 'fin',
  currency: 'EUR',
};

export const Norway: CountryConstants = {
  name: 'Norway',
  code: 'NO',
  countryFlag: 'nor',
  currency: 'NOK',
};

export const Sweden: CountryConstants = {
  name: 'Sweden',
  code: 'SE',
  countryFlag: 'swe',
  currency: 'SEK',
};

export const UnitedKingdom: CountryConstants = {
  name: 'United Kingdom',
  code: 'UK',
  countryFlag: 'uk',
  currency: 'GBP',
};
